import styles from './index.less';
import { history, useSnapshot } from 'umi';
import openPayDialog from '@/components/PayDialog';
import wsStore from '@/states/ws';
import { deleteCookie, getCookie } from '@/utils/cookie'
import { desensitizationNumber, calDate } from '@/utils/util'
import moment from 'moment';
import { userLogout } from '@/layouts/api';
import { Popover } from 'antd';
import { CUSTOMER_SERVICE_QR_CODE } from '@/constants';
import { useEffect, useState } from 'react';

export default ({ userInfo = {} }: any) => {
  const state = useSnapshot(wsStore);

  useEffect(() => {
    const unlisten = history.listen(({location, action}) => {
      // console.log(`路由变化了，新的 location 是：`, location);
      if (location.state === 'logout') {
        console.log('🚀 ~ ws pop close :')
        if (getCookie('token')) {
          userLogout().then((res) => { })
        }
        deleteCookie('userId')
        deleteCookie('token')
        deleteCookie('productMainImgCreateClickTimes')
        state.close();
        wsStore.onPortLogout()
        window.location.reload()
      }
    });

    return () => {
      // 组件卸载时取消监听
      unlisten();
    };
  }, []);

  const handleLogout = () => {
    history.push({
      pathname: '/'
    }, 'logout');
  };
  const openPay = () => {
    openPayDialog({
      onClose: e => {
        // console.log('onClose?????');
      },
    });
  };

  return (
    <div className={styles.avatarWrapper}>
      <div className={styles.avatar}>
        <img src={userInfo?.avatarUrl || ''} />
      </div>
      <div className={styles.placeWrapper}>
        <div className={styles.avatarPopup}>
          <div className={styles.userInfo} onClick={() => history.push({ pathname: '/personal-center' })}>
            <img
              className={styles.headIcon}
              src={userInfo?.avatarUrl || ''}
            />
            <div className={styles.info}>
              <p className={styles.p1}>{userInfo?.nickname || userInfo?.userId || ''}</p>
              {userInfo?.mobileNo && <p className={styles.p2}>{desensitizationNumber(userInfo?.mobileNo || '')}</p>}
              {!userInfo?.mobileNo && <div className={styles.unbind}>暂未绑定手机号</div>}
            </div>
            <div
              className={styles.personalCenter}
            >
              个人中心
              <div className='icon-ArrowRight-2' style={{ fontSize: 16, marginLeft: 2 }}></div>
            </div>
          </div>
          {userInfo.memberStatus === 1 && <div className={styles.vipWrapper}>
            <img src={'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/anniu_huiyuan.png'} />
            <div>
              <div className={styles.title}>WIME会员</div>
              {userInfo?.benefitType===127?<p className={styles.lifeMember}>你是无期限会员，永久有效</p>:<>
              <p className={styles.desc}>剩余{calDate(userInfo.memberExpireTime || '')}天</p>
              <p className={styles.selflife}>{moment(userInfo.memberExpireTime || '').format('YYYY.MM.DD')}到期</p>
              </>}
            </div>
            <button className={styles.renew} onClick={openPay}>立即续费</button>
          </div>}
          {userInfo.memberStatus !== 1 && <div className={styles.freeWrapper}>
            <div>
              <p className={styles.title}>{userInfo.memberStatus === 2 ? 'WIME会员已过期' : '免费版'}</p>
              <p className={styles.desc}>开通AI会员，畅享海量模板</p>
              <p className={styles.subDesc}>会员专属加速通道</p>
            </div>
            <button className={styles.openPay} onClick={openPay}>
              开通会员
            </button>
          </div>}
          <div className={styles.line}></div>
          <ul className={styles.operateMenu}>
            <li
                onClick={() => {
                  window.open('/my-creations')
                }}
              >
              <span className="icon-FileArticleLine" />
              我的创作
            </li>
            <Popover overlayClassName={styles.popover} arrow={false} placement="leftTop" content={
              <>
                <img src={CUSTOMER_SERVICE_QR_CODE} width={130} height={130} />
                <p style={{ fontSize: 12, color: '#8A9099', marginTop: 5, textAlign: 'center' }}>微信扫一扫，加入社群</p>
              </>
            }>
              <li>
                <span className="icon-PersonCostumerLine"/>
                加入社群
                <span className="icon-ArrowRight-2" />
              </li>
            </Popover>
        
            {/* <li>
              <img src={opinionSvg} />
              意见反馈
            </li> */}
          </ul>
          <button className={styles.logout} onClick={handleLogout}>
            退出登录
          </button>
        </div>
      </div>
    </div>
  );
};
